import { api } from 'shared';
import { z } from 'zod';

export const LeadFormResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
        commercialOfferFile: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});
export const fetchLeadForm = async () => (
    api.get<z.infer<typeof LeadFormResponseSchema>>(
        '/lead-form',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                commercialOfferFile: {
                    fields: 'url',
                },
            },
        },
        LeadFormResponseSchema,
    )
);
